// Closes an open mega menu panel on outside click or Escape; panels themselves are native <details>.
class SMegaMenu extends HTMLElement {
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;

    document.addEventListener('click', (event) => {
      if (this.contains(event.target)) return;
      this.#closeAll();
    }, { signal });

    // Mirror each disclosure's state on its summary for assistive tech that does not expose <details> state.
    const sync = (details) => details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));
    this.querySelectorAll('details').forEach(sync);
    this.addEventListener('toggle', (event) => {
      if (event.target instanceof HTMLDetailsElement) sync(event.target);
    }, { capture: true, signal });

    this.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = this.querySelector('details[open]');
      if (!open) return;
      open.removeAttribute('open');
      open.querySelector('summary')?.focus();
    }, { signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  #closeAll() {
    this.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));
  }
}

if (!customElements.get('s-mega-menu')) customElements.define('s-mega-menu', SMegaMenu);
